<template>
  <div id="app">
    <Login v-if="!loggedIn" />
    <MissingRole v-else-if="missingAuthorization" />
    <div v-else class="app-shell">
      <Sidebar />
      <div class="app-main">
        <Navbar />
        <main class="app-content">
          <ToastHost />
          <router-view />
        </main>
      </div>
      <BottomNav />
    </div>
  </div>
</template>

<script>
import ToastHost from "@/components/common/ToastHost.vue";
import Sidebar from "@/components/frame/Sidebar.vue";
import Navbar from "@/components/frame/Navbar.vue";
import BottomNav from "@/components/frame/BottomNav.vue";
import Login from "@/components/frame/Login.vue";
import MissingRole from "@/components/frame/MissingRole.vue";
import { AuthenticationContext } from "@/auth/msal-context";

import { GET_EVENTS } from "@/store/action-types";
import { EVENT_NAMESPACE } from "@/store/namespace-types";

export default {
  components: {
    Sidebar,
    Navbar,
    BottomNav,
    Login,
    MissingRole,
    ToastHost,
  },
  watch: {
    loggedIn: function (newVal, oldVal) {
      if (newVal === true && newVal != oldVal) {
        this.loadEvents();
      }
    },
  },
  methods: {
    loadEvents() {
      this.$store.dispatch(EVENT_NAMESPACE + "/" + GET_EVENTS);
    },
  },
  created() {
    this.loadEvents();
  },
  computed: {
    loggedIn() {
      return AuthenticationContext.isAuthenticated();
    },
    missingAuthorization() {
      if (this.loggedIn) {
        return !AuthenticationContext.checkRoles(["Admin", "Vorstand", "Users"]);
      }
      return true;
    },
  },
};
</script>
